import { render, staticRenderFns } from "./reportsOfficerAll.vue?vue&type=template&id=4a01f748&scoped=true"
import script from "./reportsOfficerAll.vue?vue&type=script&lang=js"
export * from "./reportsOfficerAll.vue?vue&type=script&lang=js"
import style0 from "./reportsOfficerAll.vue?vue&type=style&index=0&id=4a01f748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a01f748",
  null
  
)

export default component.exports